import styled from 'styled-components';

import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';

import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';

export default function ProductSalesDeleteModal(props) {
  const { deleteClickFn, exitClickFn } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();

  function exitClick() {
    exitClickFn();
  }

  function deleteClick() {
    deleteClickFn();
  }

  return (
    <TotalModalWrapper onClickExit={exitClick}>
      <ModalView $isDark={isDark}>
        <TotalWrapper>
          <Title>{t('memberDetail.productDeleteTitle')}</Title>
          <TextWrapper>
            <Explanation>{t('memberDetail.productDeleteDesc1')}</Explanation>
            <ExplanationWrapper>
              <Explanation>{t('memberDetail.productDeleteDesc2')}</Explanation>
              <ColorExplanation>{t('memberDetail.productDeleteRefund')}</ColorExplanation>
              <Explanation>{t('memberDetail.productDeleteDesc3')}</Explanation>
            </ExplanationWrapper>
            <Explanation>{t('memberDetail.productDeleteConfirm')}</Explanation>
          </TextWrapper>
          <ButtonWrapper>
            <ExitButton onClick={exitClick}>{t('memberDetail.modalCancel')}</ExitButton>
            <DeleteButton onClick={deleteClick}>{t('memberDetail.modalDeleteBtn')}</DeleteButton>
          </ButtonWrapper>
        </TotalWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 371px;
  height: 248px;

  border-radius: 30px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 86.34%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 14px;

  margin-top: 16px;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 4px;
`;

const ColorExplanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.pointRed};

  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 37px;

  gap: 14px;

  width: 100%;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 72px;
  height: 38px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 15px;
  background-color: ${props => props.theme.subBackground};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      border: 1px solid ${props => props.theme.subText};
      color: ${props => props.theme.text};
    }
  }
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 15px;
  background-color: ${props => props.theme.pointRed};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;
